<ws-modal-wrapper headerLabel="Contact Info" (cancel)="closeModal()" [hideFooter]="true" [loading]="loading">
    @if (!loading) {
        <div>
            <form
                name="contactForm"
                [formGroup]="contactForm"
                class="contact-form-modal mb-3"
                (ngSubmit)="saveContact()"
            >
                <div class="d-flex justify-content-between border-bottom mb-2 pb-2">
                    <div>
                        @if (!editMode) {
                            <h3 class="mb-0">{{ contact.firstName }} {{ contact.lastName }}</h3>
                        }
                        @if (editMode && contact.contactID) {
                            <button
                                type="button"
                                [attr.ws-testing]="'contact-info-delete-contact'"
                                class="ace-btn btn-sm btn-primary btn-danger"
                                (click)="deleteContact()"
                                [disabled]="loading"
                                >Delete Contact
                            </button>
                        }
                    </div>
                    <div class="d-flex align-items-center">
                        @if (hasEditPermission && !editMode) {
                            <button type="button" class="ace-btn has-icon btn-primary mb-0" (click)="editMode = true">
                                <i class="fa fa-pencil"></i>
                            </button>
                        }
                        @if (editMode) {
                            <button
                                type="submit"
                                class="ace-btn has-icon btn-primary mb-0"
                                [disabled]="contactForm.invalid || loading"
                            >
                                <i class="fa fa-save"></i>
                            </button>
                        }
                        @if (editMode) {
                            <button
                                type="button"
                                class="ace-btn has-icon btn-primary btn-danger mb-0"
                                [disabled]="loading"
                                (click)="cancelSave()"
                            >
                                <i class="fa fa-close"></i>
                            </button>
                        }
                        @if (isSingleInstanceSelected && contact.contactID) {
                            <entity-comments
                                [hasComments]="contact.hasComments"
                                buttonClass="has-icon mb-0"
                                [getModalData]="getCommentsModalData"
                            >
                            </entity-comments>
                        }
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div class="d-flex flex-column flex-grow-1 me-2">
                        <div class="d-flex align-items-center">
                            <label class="title" [ngClass]="{ required: editMode }">First Name:</label>
                            @if (contact.prefix && !editMode) {
                                <span>{{ contact.prefix }}</span>
                            }
                            @if (contact.prefix && editMode) {
                                <ws-select
                                    formControlName="prefix"
                                    name="prefix"
                                    [options]="prefixes"
                                    [isPrimitive]="true"
                                >
                                </ws-select>
                            }
                            <!--[options]="prefix.value as prefix.display for prefix in prefixes">{{contact.prefix}}</span>-->
                            @if (!editMode) {
                                <span>{{ contact.firstName }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    name="firstName"
                                    formControlName="firstName"
                                    class="form-control my-1 ms-1"
                                    maxlength="35"
                                />
                            }
                        </div>
                        <div class="d-flex align-items-center">
                            <label class="title" [ngClass]="{ required: editMode }">Last Name:</label>
                            @if (!editMode) {
                                <span>{{ contact.lastName }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    name="lastName"
                                    formControlName="lastName"
                                    class="form-control"
                                    maxlength="35"
                                />
                            }
                        </div>
                        <div class="d-flex align-items-center">
                            <label class="title">Title:</label>
                            @if (!editMode) {
                                <span>{{ contact.title }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="title"
                                    class="form-control my-1"
                                    name="title"
                                    maxlength="35"
                                />
                            }
                        </div>
                        <div class="contact-entity-name d-flex align-items-center">
                            <span class="title" [ngClass]="{ required: editMode }">Company:</span>
                            @if (!editMode) {
                                <span>{{ contact.entityName }}</span>
                            }
                            @if (editMode) {
                                <ws-company-picker
                                    class="contact-company-picker"
                                    [(companyName)]="contact.entityName"
                                    [(companyId)]="contact.companyID"
                                    [appendToBody]="true"
                                >
                                </ws-company-picker>
                            }
                        </div>
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title">Address:</span>
                            @if (!editMode) {
                                <span>{{ contact.address.address1 }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="address1"
                                    class="form-control my-1"
                                    name="address1"
                                    maxlength="50"
                                />
                            }
                        </div>
                        @if (editMode || contact.address?.address2) {
                            <div formGroupName="address" class="d-flex align-items-center">
                                <span class="title"></span>
                                @if (!editMode) {
                                    <span>{{ contact.address.address2 }}</span>
                                }
                                @if (editMode) {
                                    <input
                                        type="text"
                                        formControlName="address2"
                                        class="form-control"
                                        name="address2"
                                        maxlength="50"
                                    />
                                }
                            </div>
                        }
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title"></span>
                            @if (!editMode) {
                                <span class="me-1">{{ contact.address.city }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="city"
                                    class="form-control my-1 me-1"
                                    name="city"
                                    maxlength="50"
                                />
                            }
                            <state-dropdown
                                formControlName="stateID"
                                [includeBlank]="true"
                                [canSearch]="true"
                                [readOnly]="!editMode"
                            >
                            </state-dropdown>
                            @if (!editMode) {
                                <span class="ms-1">{{ contact.address.zip }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="zip"
                                    class="form-control my-1 ms-1"
                                    name="zip"
                                    maxlength="10"
                                />
                            }
                        </div>
                        @if (!contact.contactID) {
                            <div class="d-flex align-items-center mt-3">
                                <span class="title">Role:</span>
                                @if (!editMode) {
                                    <span>{{ this.contactForm.get('contactRole')?.value?.roleDesc }}</span>
                                }
                                @if (editMode) {
                                    <ws-select
                                        formControlName="contactRole"
                                        name="role"
                                        [options]="availableRoles"
                                        labelProperty="roleDesc"
                                        [returnEntireOption]="true"
                                    >
                                    </ws-select>
                                }
                            </div>
                        }
                    </div>
                    <div class="d-flex flex-column flex-grow-1 ms-2">
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title">Office Phone:</span>
                            @if (!editMode) {
                                <span>{{ contact.address.phone }}</span>
                            }
                            @if (editMode) {
                                <input type="text" formControlName="phone" class="form-control my-1" name="phone" />
                            }
                            @if (!editMode) {
                                <span>{{ contact.address.ext }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="ext"
                                    class="form-control my-1 ms-1"
                                    name="ext"
                                    maxlength="10"
                                />
                            }
                        </div>
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title">Mobile Phone:</span>
                            @if (!editMode) {
                                <span>{{ contact.address.mobilePhone }}</span>
                            }
                            @if (editMode) {
                                <input
                                    type="text"
                                    formControlName="mobilePhone"
                                    class="form-control"
                                    name="mobilePhone"
                                />
                            }
                        </div>
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title">Fax Number:</span>
                            @if (!editMode) {
                                <span>{{ contact.address.fax }}</span>
                            }
                            @if (editMode) {
                                <input type="text" formControlName="fax" class="form-control my-1" name="fax" />
                            }
                        </div>
                        <div formGroupName="address" class="d-flex align-items-center">
                            <span class="title">Email:</span>
                            @if (!editMode) {
                                <a href="mailto:{{ contact.address?.email }}">{{ contact.address?.email }}</a>
                            }
                            @if (editMode) {
                                <input
                                    type="email"
                                    formControlName="email"
                                    class="form-control"
                                    name="email"
                                    maxlength="100"
                                />
                            }
                        </div>
                        <div class="text-center mt-2">
                            @if (!editMode && contactForm?.controls['active'].value) {
                                <span> <i class="fa fa-check"></i> Active </span>
                            }
                            @if (editMode) {
                                <div class="checkbox">
                                    <label> <input type="checkbox" formControlName="active" /> Active </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </form>
            <!-- <div *ngIf="!isSingleInstanceSelected" class="text-center" style="margin-top:20px;">
    <strong><i class="fa fa-info-circle fa-fw"></i>&nbsp Some features are only available if you have a single instance selected</strong>
  </div>	 -->
            <!-- <div *ngIf="isSingleInstanceSelected"> -->
            <div>
                <!-- <uib-tabset *ngIf="contact.contactID && isSingleInstanceSelected"> -->
                @if (contact.contactID) {
                    <ws-ace-tab-set [input]="aceTabs">
                        <ws-ace-tab-content heading="Roles">
                            <div style="max-height: 300px; overflow-y: auto">
                                <table class="ace-table w-100">
                                    <thead>
                                        <tr>
                                            <th>Entity</th>
                                            <th>Role</th>
                                            <th>Last Updated</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (
                                            role of contact.contactRoleAssociations
                                                | sortBy: 'asc' : ['entityName', 'roleDesc'];
                                            track role
                                        ) {
                                            <tr>
                                                <td>{{ role.entityName }}</td>
                                                <td>{{ role.roleDesc }}</td>
                                                <td><span am-time-ago="role.changeDate"></span></td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </ws-ace-tab-content>
                        @if (canManageUsers) {
                            <ws-ace-tab-content heading="User Setup" (tabChange)="userSetupSelected = $event">
                                <user-setup
                                    [contact]="contact"
                                    [tabSelected]="userSetupSelected"
                                    [modalRef]="bsModalRef"
                                    (isEditing)="tabEditMode = $event"
                                >
                                </user-setup>
                            </ws-ace-tab-content>
                        }
                        @if (contact.userID && canManageUsers) {
                            <ws-ace-tab-content heading="Team Assignments">
                                <team-assignment-panel [user]="contact"></team-assignment-panel>
                            </ws-ace-tab-content>
                        }
                        @if (contact.userID && (canManageUsers || loggedInUserId === contact.userID)) {
                            <ws-ace-tab-content heading="Signature">
                                <signature-panel [search]="search" [contact]="contact"></signature-panel>
                            </ws-ace-tab-content>
                        }
                    </ws-ace-tab-set>
                }
            </div>
        </div>
    }
</ws-modal-wrapper>
